import React, { useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { TextArea, SmallBtn } from "@/components/praticien/fiche/ui";

const uid = () => Math.random().toString(36).slice(2, 9);

// Rubrique d'activités réutilisable (sections 6 à 9).
export const Activities = ({ options, value, onChange, lang, T, prefix }) => {
  const items = value.items || {};
  const custom = value.custom || [];
  const [label, setLabel] = useState("");

  const toggle = (key) => {
    const it = items[key] || { checked: false, note: "" };
    onChange({ ...value, items: { ...items, [key]: { ...it, checked: !it.checked } } });
  };
  const setNote = (key, note) => {
    const it = items[key] || { checked: true, note: "" };
    onChange({ ...value, items: { ...items, [key]: { ...it, note } } });
  };
  const addCustom = () => {
    const l = label.trim();
    if (!l) return;
    onChange({ ...value, custom: [...custom, { id: uid(), label: l, note: "" }] });
    setLabel("");
  };
  const setCustom = (id, patch) => onChange({ ...value, custom: custom.map((c) => (c.id === id ? { ...c, ...patch } : c)) });
  const removeCustom = (id) => onChange({ ...value, custom: custom.filter((c) => c.id !== id) });

  return (
    <div className="space-y-3">
      {options.map((opt) => {
        const it = items[opt.key] || { checked: false, note: "" };
        return (
          <div key={opt.key} className="rounded-2xl border border-[var(--border)] bg-white/70 p-3.5" data-testid={`${prefix}-item-${opt.key}`}>
            <label className="flex items-center gap-2.5 cursor-pointer">
              <input type="checkbox" checked={!!it.checked} onChange={() => toggle(opt.key)} data-testid={`${prefix}-check-${opt.key}`}
                className="h-4 w-4 accent-[var(--gold)]" />
              <span className="font-medium text-[var(--ink)]">{opt[lang]}</span>
            </label>
            {it.checked && (
              <div className="mt-2.5 pl-7">
                <TextArea value={it.note} onChange={(v) => setNote(opt.key, v)} testid={`${prefix}-note-${opt.key}`} placeholder={T.itemNote} rows={2} />
              </div>
            )}
          </div>
        );
      })}

      {custom.map((c) => (
        <div key={c.id} className="rounded-2xl border-2 border-dashed border-[var(--gold-light)] bg-white/70 p-3.5" data-testid={`${prefix}-custom-${c.id}`}>
          <div className="flex items-center gap-2 mb-2">
            <input value={c.label} onChange={(e) => setCustom(c.id, { label: e.target.value })} data-testid={`${prefix}-custom-label-${c.id}`}
              placeholder={T.customLabel}
              className="flex-1 rounded-xl border border-[var(--border)] bg-white/80 px-3 py-1.5 text-sm font-medium text-[var(--ink)] focus:outline-none focus:ring-2 focus:ring-[var(--gold-light)]" />
            <button onClick={() => removeCustom(c.id)} data-testid={`${prefix}-custom-remove-${c.id}`} className="text-[#B0553B] hover:opacity-70"><Trash2 size={16} /></button>
          </div>
          <TextArea value={c.note} onChange={(v) => setCustom(c.id, { note: v })} testid={`${prefix}-custom-note-${c.id}`} placeholder={T.itemNote} rows={2} />
        </div>
      ))}

      <div className="flex gap-2">
        <input value={label} onChange={(e) => setLabel(e.target.value)} placeholder={T.customLabel} data-testid={`${prefix}-custom-input`}
          className="flex-1 rounded-xl border border-[var(--border)] bg-white/80 px-3.5 py-2 text-sm text-[var(--ink)] focus:outline-none focus:ring-2 focus:ring-[var(--gold-light)]" />
        <SmallBtn onClick={addCustom} testid={`${prefix}-custom-add`}><Plus size={14} /> {T.addCustom}</SmallBtn>
      </div>

      <TextArea label={T.sectionComment} value={value.commentaire} onChange={(v) => onChange({ ...value, commentaire: v })} testid={`${prefix}-comment`} rows={2} />
    </div>
  );
};
